import { Dialog, Text, Layout } from '@loadsmart/miranda-react'

import { type RequestStatus } from 'core/domain/Request'
import { formatCurrency } from 'core/utils/currency'

export type BookNowBannerProps = {
  rate?: string
  onCancel?: () => void
  onConfirm?: () => void
  bookNowStatus?: RequestStatus
}

export type BookNowConfirmDialogProps = {
  targetRate?: string
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function BookNowConfirmDialog({
  isOpen,
  targetRate,
  onCancel,
  onConfirm,
}: BookNowConfirmDialogProps) {
  return (
    <Dialog open={isOpen}>
      <Dialog.Header>Book Now</Dialog.Header>
      <Dialog.Body>
        <Layout.Stack gap="spacing-2">
          <Text variant="body-md">
            You’re about to book this shipment using the target rate of{' '}
            {formatCurrency(Number(targetRate), true)} proposed by the shipper.
          </Text>

          <Text variant="body-sm">
            If shipper requested any accessorial charges, those won’t be considered in the target
            rate total.
          </Text>
        </Layout.Stack>
      </Dialog.Body>
      <Dialog.Actions>
        <Dialog.ActionTertiary onClick={onCancel}>Cancel</Dialog.ActionTertiary>
        <Dialog.ActionPrimary onClick={onConfirm} data-testid="dialog-confirm-book-now">
          Book Now
        </Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>
  )
}
